import "objectFitPolyfill"

import smoothScroll from "smoothscroll-polyfill"

smoothScroll.polyfill()
